import { MaintenancePaymentAgreementModel } from 'api/models';

export const percentages = {
  zero: 0,
  fifty: 50,
  oneHundred: 100,
};
export const result = {
  approved: 'approved',
  rejected: 'rejected',
  shared: 'shared',
};
export type ResponsibilityResult = (typeof result)[keyof typeof result];
/**
 * The two cleared fields are `null` here, not absent: the form resets them to
 * `null` on approval and posts them that way. The generated model spells absence
 * as `undefined`, so they are widened rather than the values being changed.
 */
export type FormValues = Omit<
  MaintenancePaymentAgreementModel,
  'notes' | 'rejectionReason'
> & {
  result: ResponsibilityResult;
  notes: MaintenancePaymentAgreementModel['notes'] | null;
  rejectionReason: MaintenancePaymentAgreementModel['rejectionReason'] | null;
};
/**
 * What the form posts: the two cleared fields keep the form's `null`, so this is
 * deliberately not `MaintenancePaymentAgreementModel`.
 */
export type SubmitValues = Pick<FormValues, 'notes' | 'rejectionReason'> & {
  isApproved: boolean;
  percentage: MaintenancePaymentAgreementModel['percentage'];
};

export const initialValues: FormValues = {
  result: result.approved,
  isApproved: true,
  percentage: percentages.oneHundred,
  notes: null,
  rejectionReason: null,
};
